// extracted by mini-css-extract-plugin
export default {"root":"style_root__drVaO","message":"style_message__Zrevr","svg":"style_svg__13ifU"};